import TaxChangeEventTracker from "../../../datasets/tax_change_event_tracker";

export const updateEventArr = (processName, dataObject, gameData, savingsInfo, currentCard, newTaxAmt) => {
    let eventDetail = {};
    switch (processName){
        case"RegularCard":
            delete dataObject.closureText;
            delete dataObject.odds;
            delete dataObject.possibleValues;
            let tableObj = {};
            if (dataObject.category !== "cash"){
                const objectDesc = this.determineObjectDesc(dataObject.itemDesc, this.gameInfo.currentCard.title, 
                    dataObject.btnText);
                tableObj = this.getGameTableObject(dataObject.category, dataObject.on, objectDesc);                       
            }
            eventDetail = {...dataObject, title: this.gameInfo.currentCard.title, 
                changeType: this.gameInfo.currentCard.cardType, tableItemChanged: tableObj,
                creditCardAmount: this.creditCardAmount, cashAfterCreditCard: this.cashAfterCreditCard};
            break;
        case "TaxChange":
            eventDetail = TaxChangeEventTracker;
            eventDetail.value = newTaxAmt;
            eventDetail.tableItemChanged = dataObject;
            break;
        case "LastCard":
            let monthlySavingsAmt = 0;
            if (savingsInfo.gameID){
                const savingsArr = savingsInfo.savingsArr;
                for (let i=0; i<savingsArr.length; i++){
                    monthlySavingsAmt += +savingsArr[i].monthlyDepositAmt;
                }
            }
            eventDetail = {btnText: currentCard.buttonText, title: currentCard.title, 
                livingExpense:  dataObject.expenseAmtChange, savingsDeposit: monthlySavingsAmt,
                expireTable: dataObject.expireTableArr, monthsPerTurn: dataObject.monthsPerTurn, 
                moodPoints: dataObject.additionalMoodPoints, creditCardActive: dataObject.creditCardActive,
                creditCardBalance: dataObject.creditCardBalance, creditCardMinPayment: dataObject.creditCardMinPayment, 
                nonCreditCardExpenses: dataObject.nonCreditCardExpense
                };
            break;
        case "PendingJob":
            const jobChangeInfo = {previous: gameData.jobInfo.careerName, 
                new: gameData.pendingJob.careerName};
            eventDetail = {newSalary: gameData.jobInfo.newMonthlySalary,
                triggerCondition: dataObject.jobConditions[0].condName, 
                deleteClass: dataObject.jobConditions[0].condClass, 
                loanTable: dataObject.loanTable,
                detailEventInfo: jobChangeInfo,
                processName: processName};
            break;
        default:
            break;         
    }
    return eventDetail;
}
export default updateEventArr;